<template>
    <div class="project-diary">
        <card
            :hide-content="true"
            icon="mdi-book-open-outline"
            :label-top-left="getLabel"
            :label-bottom-left="$t('txt.project.projectDairy')"
        >
            <template slot="header">
                <v-btn
                    fab
                    small
                    color="primary"
                    @click="addPost()"
                    elevation="0"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </template>
        </card>
        <posts
                v-model="posts"
                :target-id="targetId"
                ref="posts"
                :loading="loading"
                :class="{
                     'mt-8': !loading,
                     'mt-4': loading
                }"
        ></posts>
    </div>
</template>

<script>
import Posts from "../../components/block/Talk/Posts";

export default {
    components: {Posts},
    data() {
        return {
            project: {},
            posts: [],
            loading: false,
            targetId: null,
        }
    },
    computed: {
        getLabel() {
            if (this.project.name) {
                return this.$t('msg.targetDiary')+' "'+this.project.name+'"';
            }
            return this.$t('msg.targetDiary');
        }
    },
    methods: {
        loadProject() {
            this.$store.dispatch('loadTarget', {id: this.targetId})
                .then(res => {
                    this.project = res;
                    this.$store.commit('setBreadcrumbs', [{id: 1, name: this.project.name}]);
                });
        },
        loadTargetDairies() {
            this.loading = true;
            this.$store.dispatch('loadTargetDairies', {id: this.targetId})
                .then(res => this.posts = res)
                .finally(() => this.loading = false);
        },
        addPost() {
            this.posts.unshift({
                id: null,
                target_id: this.targetId,
                date: null,
                msg: null,
                count_comments: 0,
                day: null
            });
            this.$store.dispatch('countDayTarget', {id: this.targetId})
                .then(res => this.posts[0].day = res.count);
            this.$refs.posts.indexOpenForm = 0;
        }
    },
    created() {
        this.targetId = parseInt(this.$route.params.id);

        this.loadProject();
        this.loadTargetDairies();
    }
}
</script>

<style>
.project-diary {}
</style>